import { JsonFormsStateProps } from "components/CRPComponents/JsonForm/JsonFormsComponent/types";
import { useCallback } from "react";
import { SchemaData } from "./types";
import { CreateGql, CREATE_QUERY } from "../queries/create";
import { useNavigate } from "react-router-dom";
import { ApiAuthRequest } from "data/ApiForm";
import { Sites } from "data/utils/globals";

export default function useCreate() {
  const navigate = useNavigate();

  const handleSave = useCallback(async (state: JsonFormsStateProps<SchemaData>) => {
    const data = state?.data;

    if (!isNaN(Number(data?.slug))) {
      throw {
        message: "Slug inválido. O slug não pode ser um numeral",
        errors: [
          {
            instancePath: "/slug",
            message: "Inválido. Não pode ser um numeral",
            schemaPath: "/slug",
            keyword: "slug",
            params: {},
          },
        ],
      };
    }

    const response = await ApiAuthRequest<CreateGql>({
      query: CREATE_QUERY,
      variables: { data },
    });

    if (response?.data?.errors) {
      throw response.data.errors[0];
    }
    if (!response?.data?.data || !response?.data?.data?.createFormWithProperties?.id) {
      throw new Error("Ops. Sem resposta!");
    }

    navigate(`${Sites.UNIFTEC.path}/forms`);

    return response;
  }, []);

  return {
    handleSave,
  };
}
